import React from 'react'

import Switch from "react-switch";

import Select from "../common/Select"

import Div from "../layouts/Div"

import Backend from "../../../utils/Backend"
import Notify from "../../../utils/Notify"
import AuthManager from "../../../utils/AuthManager"
import General from "../../../utils/General"

const MESSAGE_NOTIFICATIONS_ENAABLED_OPTIONS = [
  {
    label: "Yes, I Want To Be Notified When Visitors Message Me",
    value: false
  },
  {
    label: "No, I Don't Want To Be Notified When Visitors Message Me",
    value: true
  },
]

const CRM_NOTIFICATIONS_ENAABLED_OPTIONS = [
  {
    label: "Yes, I Want To Be Notified When I Receive A New Lead",
    value: false
  },
  {
    label: "No, I Don't To Be Notified When I Receive A New Lead",
    value: true
  },
]

export default class NotificationSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      loading: false,
      data: General.clone(AuthManager.currentUser)
    }

  }

  _handleChange(e) {
    let data = this.state.data
    data[e.target.name] = e.target.value
    this.setState({ data, error: null })
  }

  _handleUpdate(){
    let {
      data
    } = this.state
    this.setState({ loading: true })

    Backend.updateCompanyMember(data)
    .then(() => {
      this.setState({ loading: false })
      Notify.success("Notification Settings Updated")
    })
    .catch(error => {
      this.setState({ loading: false })
      Notify.error(error.message)
    })
  }

  render(){
    let {
      data,
      loading,
    } = this.state

    return (
      <>
        <Div
          className="kt-wizard-v2__content"
          data-ktwizard-type="step-content"
          data-ktwizard-state="current"
          disabled={loading}
        >
          <div className="kt-heading kt-heading--md">
            Notification Settings
          </div>

          <div className="form-group row align-items-center">
            <label className="col-lg-3 col-form-label">Daily Stat Summary</label>
            <div className="col-auto">
              <Switch
                onChange={checked => {
                  data.notify_daily_stat_summary = checked
                  this.setState({ data })
                }}
                checked={data.notify_daily_stat_summary }
                aria-labelledby="neat-label"
                onColor="#333333"
                offColor="#F3F6F9"
                checkedIcon={null}
                uncheckedIcon={null}
                className="c-switch"
                />
            </div>
          </div>

          <div className="form-group row align-items-center">
            <label className="col-lg-3 col-form-label">New Live Chat</label>
            <div className="col-auto">
              <Switch
                onChange={checked => {
                  data.notify_message = checked
                  this.setState({ data })
                }}
                checked={data.notify_message }
                aria-labelledby="neat-label"
                onColor="#333333"
                offColor="#F3F6F9"
                checkedIcon={null}
                uncheckedIcon={null}
                className="c-switch"
                />
            </div>
          </div>

        </Div>
        <div className="kt-form__actions pull-right">
          <a
            href="javascript:void()"
            className="btn btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u"
            onClick={e => this._handleUpdate()}>
              Update
            </a>
        </div>
      </>
    )
  }
}
